<template>
	<div class="modal-holder freeze" :class="{'is-closing': isClosing}" v-if="isVisible">
		<div class="modal-backdrop" @click="close()"></div>
		<div class="modal">
			<div class="modal-close" @click="close()"><svg><use xlink:href="#cross"></use></svg></div>
			<div class="modal-body">
				<div class="content">
					<h4>Fibre installation delay over the festive period.</h4>
					<p>Please note that Fibre orders placed during the freeze period may only be scheduled for installation from late January 2024. Below are the freeze period dates for each respective Fibre provider.</p>
				</div>
				<div class="freeze-list">
					<dl class="header"><dt>Fibre Provider</dt><dd>Freeze period</dd></dl>
					<dl><dt>Balwin</dt><dd>13 Dec '24 - 06 Jan '25</dd></dl>
					<dl><dt>Clear Access</dt><dd>13 Dec '24 - 06 Jan '25</dd></dl>
<!--					<dl><dt>MFN</dt><dd>14 Dec '24 - 07 Jan '25</dd></dl>-->
					<dl><dt>Vumatel</dt><dd>13 Dec '24 - 02 Jan '25</dd></dl>
					<dl><dt>Frogfoot</dt><dd>13 Dec '24 - 06 Jan '25</dd></dl>
					<dl><dt>Openserve</dt><dd>21 Dec '24 - 05 Jan '25</dd></dl>
					<dl><dt>Metrofibre</dt><dd>13 Dec '24 - 06 Jan '25</dd></dl>
					<dl><dt>Evotel</dt><dd>20 Dec '24 - 06 Jan '25</dd></dl>
					<dl><dt>Mitsol</dt><dd>13 Dec '24 - 06 Jan '25</dd></dl>
					<dl><dt>Octotel</dt><dd>25 Dec '24, 26 Dec '24, and 1 Jan '25</dd></dl>
					<dl><dt>Netstream</dt><dd>13 Dec '24 - 03 Jan '25</dd></dl>
					<dl><dt>TT Connect</dt><dd>13 Dec '24 - 06 Jan '25</dd></dl>
					<dl><dt>Purple Forest</dt><dd>13 Dec '24 - 06 Jan '25</dd></dl>
					<dl><dt>WAN</dt><dd>13 Dec '24 - 06 Jan '25</dd></dl>
					<dl><dt>DNATel</dt><dd>13 Dec '24 - 13 Jan '25</dd></dl>
					<dl><dt>FibreSuburb Networks</dt><dd>15 Dec '24 - 15 Jan '25</dd></dl>
					<dl><dt>Lightstruck</dt><dd>13 Dec '24 - 06 Jan '25</dd></dl>
					<dl><dt>Link layer</dt><dd>20 Dec '24 - 06 Jan '25</dd></dl>
					<dl><dt>Open Fibre</dt><dd>12 Dec '24 - 13 Jan '25</dd></dl>
					<dl><dt>Fibonacci</dt><dd>13 Dec '24 - 15 Jan '25</dd></dl>
					<dl><dt>Connectivity services</dt><dd>13 Dec '24 - 06 Jan '25</dd></dl>
					<dl><dt>Zoom</dt><dd>13 Dec '24 - 06 Jan '25</dd></dl>
					<dl><dt>Think Speed</dt><dd>13 Dec '24 - 07 Jan '25</dd></dl>
					<dl><dt>Unifybr</dt><dd>25 Dec '24, 26 Dec '24, and 1 Jan '25</dd></dl>
					<dl><dt>Link Africa</dt><dd>N/A</dd></dl>
					<dl><dt>Vodacom</dt><dd>N/A</dd></dl>
					<dl><dt>Comtel</dt><dd>N/A</dd></dl>
					<dl><dt>Route Networks</dt><dd>N/A</dd></dl>
				</div>
			</div>
		</div><!-- end.modal -->
	</div><!-- end.modal-holder -->
</template>

<script>

export default {
	components: {

	},
	computed: {
		isVisible() {
			return this.$store.getters['general/freezeModalVisible'];
		},
	},
	data() {
		return {
			isClosing: false
		}
	},
	methods: {
		close() {
			this.isClosing = true;
			setTimeout(() => {
				this.$store.commit('general/updateFreezeModalVisibility', false);
				this.isClosing = false;
			}, 300);
		}
	},
	mounted() {
		this.$on('close', () => {
			this.close();
		});
	}
}
</script>

<style lang="scss">
@import "resources/assets/main/scss/setup/variables";
@import "resources/assets/main/scss/setup/mixins";

.modal-holder.freeze {


	.modal {
		border-radius: 1rem;

		@media all and (max-width: 600px) {
			top: 4rem;
			bottom: 2rem;
			left: 1rem;
			right: 1rem;
		}

	}

	.modal-backdrop {
		@media all and (max-width: 600px) {
			display: block;
		}
	}

	.modal-close {
		background: none;
		transform: none;
		top: -3rem;
		width: 1.5rem;
		height: 1.5rem;

		svg {
			width: 1.5rem;
			height: 1.5rem;
		}
	}

	.modal-body {
		max-width: 100%;
		width: 89rem;
		padding: 6rem 3rem 4rem;
		background: none;

		.content {
			padding: 0 3.7rem;
			margin-bottom: 4rem;

			h4 {
				font-size: 2.2rem;
				font-weight: bold;
				color: #1d8296;
				margin-bottom: 2rem;
			}

			p {
				font-size: 1.2rem;
				line-height: 1.8rem;
				max-width: 60.5rem;
				font-weight: $font-weight-medium;
			}
		}

		.freeze-list {
			border-radius: 1rem;

			dl {
				display: flex;
				justify-content: space-between;
				align-items: center;
				height: 4.8rem;
				padding: 0 4rem;
				border: .1rem solid #e0e0e0;

				dt,
				dd {
					width: 50%;
					font-size: 1.2rem;
					line-height: 1.8rem;
					font-weight: $font-weight-medium;
				}

				&:not(.header) {
					border-top: none;
				}

				&:nth-of-type(2n) {
					background: #fafafa;
				}

				&.header {
					height: 6rem;
					border-radius: 1rem 1rem 0 0;
					background: linear-gradient(180deg, rgb(255,255,255) 0%, rgb(246,246,254) 50%);

					dt,
					dd {
						font-size: 1.4rem;
						color: #1d8296;
					}
				}

				&:last-of-type {
					border-radius: 0 0 1rem 1rem;
				}
			}
		}

		@media all and (max-width: 600px) {
			padding: 6rem 1rem 4rem 1rem;
			height: 100%;

			.content {
				padding: 0 1rem;
			}

			.freeze-list dl {
				padding: 0 2rem;
			}
		}
	}
}

</style>
